import {deleteAssets} from './deleteAsset'
import {getSavedSnapshot} from '../components/store/savedSnapshotStore'

/**
 * When the editor replaces an image, delete the previous own-uploaded S3 object right
 * away so it doesn't linger as a quota-consuming zombie. Only deletes session uploads
 * that are NOT yet persisted in the saved project: a key still referenced by the last
 * saved snapshot is left to the save-time orphan cleanup, so we never break the
 * currently-saved project if the user replaces then navigates away without saving.
 * Predefined (_ecranify/*) keys are shared and never deleted.
 */
export const cleanupReplacedAsset = (oldKey: string | null | undefined): void => {
  if (!oldKey || oldKey.startsWith('_ecranify/')) return
  const snapshot = getSavedSnapshot()
  if (snapshot && snapshot.includes(oldKey)) return
  void deleteAssets([oldKey])
}
